export abstract class AbstractStorage<T> {
  abstract get<S>(key: string): S;

  abstract version(): string;

  abstract save(): boolean;

  abstract set<S>(key: string, value: S, ttl: number): boolean;

  abstract delete(key: string): boolean;

  abstract flush(): boolean;

  abstract getAll(): { [p: string]: T };

  abstract getAllRaw(): T;

  abstract load(): boolean;

  abstract isAvailable(): boolean;

  constructor() {
    this.load();
  }
}
